export const activityGoods = {
  clickSearch: '2010.0', // 特惠活动页点击搜索框
  clickClassify: '2011.0', // 特惠活动页点击分类
  sortPrice: '2012.0', // 特惠活动页点击价格排序
  clickFilter: '2013.0', // 特惠活动页点击筛选
  plusCar: '2014.0', // 特惠活动页点击商品加购
  minusCar: '6843.0', // 特惠活动页点击减购
  goDetail: '179.0', // 活动商品聚合页-点击商品进商详点击
  goodExpose: '179.0' // 活动商品聚合页-商品曝光
}
